import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputLabel,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";

import { useState } from "react";
import { useForm } from "react-hook-form";
const EditCreditNoteDialog = ({
  handleConfirmation,
  message,
  render,
  ...props
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const handleEdit = () => {
    handleConfirmation(formData);
    setIsPopupOpen(false);
  };
  const inputFieldData = {
    _id: props._id,
    creditNote: props.creditNote,
  };
  const [formData, setFormData] = useState(inputFieldData);

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleClose = () => {
    setFormData(inputFieldData);
    setIsPopupOpen(false);
  };

  const handlePopupOpen = () => setIsPopupOpen(true);

  return (
    <>
      <Dialog open={isPopupOpen}>
        <DialogTitle
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Edit Credit Limit
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid
              item
              display={"flex"}
              justifyContent={"flex-start"}
              flexDirection={"column"}
              gap={"5px"}
              width={"90%"}
              margin={"10px"}
            >
              <InputLabel fullWidth>New Credit Note</InputLabel>
              <TextField
                type="number"
                placeholder="New Credit Note"
                name="creditNote"
                value={formData.creditNote}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>cancel</Button>
          <Button
            type="submit"
            onClick={() => {
              handleEdit();
              //   toast.success("Credit Limit updated successfully");
            }}
          >
            save
          </Button>
        </DialogActions>
      </Dialog>
      {render(handlePopupOpen, isPopupOpen)}
    </>
  );
};

export default EditCreditNoteDialog;
